import { Stack } from 'design-system'
import { FC } from 'react'

import { ExpandableSection } from 'src/components/board/archived/expandable-section'

export const ContractExpiredMemberView: FC = () => (
  <div className="py-4 text-left text-slate-500">
    Your institution’s Yellowdig access has ended, so your communities are
    paused for now. Your institution administrators have been notified.
    <Stack gap={3}>
      <ExpandableSection message="What happens to my content and data?">
        All points earned up to now are saved in your LMS gradebook and will
        remain saved there. Your community data also stays intact during a data
        retention period subject to the terms of our agreements. During this
        period, all posts, discussions, and member data are preserved and would
        return in full once access is restored.
      </ExpandableSection>
      <ExpandableSection message="Who should I contact?">
        If you’re a student, start with your instructor or community owner, who
        can check on your institution’s plans. If you’re an instructor or
        community owner, reach out to your Network Admin or Contract Owner, who
        can restore access. For anything else, our team is here at{' '}
        <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>.
      </ExpandableSection>
    </Stack>
  </div>
)
